"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigestReference = exports.isExpectedEnum = exports.MotSurveyCategory = exports.FeedbackCategory = exports.UserFeedbackAction = exports.Feedback = void 0;
class Feedback {
}
exports.Feedback = Feedback;
var UserFeedbackAction;
(function (UserFeedbackAction) {
    UserFeedbackAction["USER_NOTIFICATION_PREFERENCES_UNSUBSCRIBE"] = "USER_NOTIFICATION_PREFERENCES_UNSUBSCRIBE";
    UserFeedbackAction["MOT_USEFULNESS_SURVEY_RESPONSE"] = "MOT_USEFULNESS_SURVEY_RESPONSE";
})(UserFeedbackAction || (exports.UserFeedbackAction = UserFeedbackAction = {}));
var FeedbackCategory;
(function (FeedbackCategory) {
    FeedbackCategory["INACCURATE_DATA"] = "INACCURATE_DATA";
    FeedbackCategory["TOO_FREQUENT"] = "TOO_FREQUENT";
    FeedbackCategory["NO_SIGNUP"] = "NO_SIGNUP";
    FeedbackCategory["IRRELEVANT"] = "IRRELEVANT";
    FeedbackCategory["OTHER"] = "OTHER";
    FeedbackCategory["YES"] = "YES";
    FeedbackCategory["NO"] = "NO";
})(FeedbackCategory || (exports.FeedbackCategory = FeedbackCategory = {}));
var MotSurveyCategory;
(function (MotSurveyCategory) {
    MotSurveyCategory["CRD"] = "CRD";
    MotSurveyCategory["ROLLOVER"] = "ROLLOVER";
    MotSurveyCategory["MAIN_CARRIAGE"] = "MAIN_CARRIAGE";
    MotSurveyCategory["CUSTOMS"] = "CUSTOMS";
    MotSurveyCategory["DEM_DET"] = "DEM_DET";
    MotSurveyCategory["NOT_ENGAGED"] = "NOT_ENGAGED";
})(MotSurveyCategory || (exports.MotSurveyCategory = MotSurveyCategory = {}));
function isExpectedEnum(reference, expectedEnum) {
    return Object.values(expectedEnum).includes(reference);
}
exports.isExpectedEnum = isExpectedEnum;
function isDigestReference(reference) {
    return reference === 'DailyDigest';
}
exports.isDigestReference = isDigestReference;
//# sourceMappingURL=userFeedback.model.js.map